import { getMangoApiClient } from '~/atoms/MangoApi'

import { createUserGroupApi } from '@mangovoice/user-groups-ui'

export const userGroupApi = createUserGroupApi(getMangoApiClient().userGroups)
